(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magazine-studio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mgzReady) return;
    window.__mgzReady = true;

    /* ---------- スライダー（商品画像・ギャラリー） ---------- */
    function items(track) { return Array.prototype.slice.call(track.children); }

    function currentIndex(track) {
      var list = items(track);
      if (!list.length) return 0;
      var base = list[0].offsetLeft, best = 0, min = Infinity;
      list.forEach(function (el, i) {
        var d = Math.abs(el.offsetLeft - base - track.scrollLeft);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }

    function goTo(track, i) {
      var list = items(track);
      if (!list.length) return;
      i = Math.max(0, Math.min(list.length - 1, i));
      track.scrollTo({ left: list[i].offsetLeft - list[0].offsetLeft, behavior: 'smooth' });
    }

    function syncDots(track) {
      var root = track.closest('[data-mgz-carousel]');
      if (!root) return;
      var i = currentIndex(track);
      root.querySelectorAll('[data-mgz-dot]').forEach(function (dot, n) {
        dot.classList.toggle('is-active', n === i);
        if (n === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    }

    /* ---------- 読了プログレスバー ---------- */
    function updateProgress() {
      document.querySelectorAll('[data-mgz-progress]').forEach(function (bar) {
        var root = bar.closest('.mgz');
        if (!root) return;
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight;
        var total = r.height - vh;
        var p = total > 0 ? -r.top / total : (r.top < 0 ? 1 : 0);
        p = Math.max(0, Math.min(1, p));
        bar.firstElementChild.style.transform = 'scaleX(' + p + ')';
        bar.style.opacity = (r.top < vh * 0.3 && r.bottom > 0) ? '1' : '0';
      });
    }

    /* ---------- マーカーが引かれるアニメーション ---------- */
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -15% 0px' }) : null;

    function initAnim() {
      document.querySelectorAll('.mgz--anim em:not([data-mgz-seen])').forEach(function (em) {
        em.setAttribute('data-mgz-seen', '');
        if (io) io.observe(em); else em.classList.add('is-in');
      });
    }

    /* ---------- 商品購入カード ---------- */
    function formatMoney(cents, format) {
      var amount = (cents || 0) / 100;
      var formatAmount = function (key) {
        var decimals = key.indexOf('no_decimals') > -1 ? 0 : 2;
        var comma = key.indexOf('comma_separator') > -1;
        var parts = amount.toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
        return parts.join(comma ? ',' : '.');
      };
      /* format はショップの通貨表示形式（data-money-format）。無いときは円表示 */
      if (!format) return '¥' + formatAmount('amount_no_decimals');
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) { return formatAmount(key); });
    }

    function buyVariants(root) {
      if (!root.__mgzVariants) {
        var json = root.querySelector('[data-mgz-variants]');
        root.__mgzVariants = json ? JSON.parse(json.textContent) : [];
      }
      return root.__mgzVariants;
    }

    function updateBuy(root, moveImage) {
      var variants = buyVariants(root);
      var sets = Array.prototype.slice.call(root.querySelectorAll('[data-mgz-optset]'));
      var selected = sets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      var find = function (values) {
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === values[i]; }); });
      };
      var variant = sets.length ? find(selected) : variants[0];

      sets.forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (input) {
          var trial = selected.slice(); trial[i] = input.value;
          var match = find(trial);
          input.closest('.mgz-chip').classList.toggle('is-soldout', !match || !match.available);
        });
        var out = fs.querySelector('[data-mgz-optval]');
        if (out) out.textContent = selected[i] || '';
      });

      var format = root.getAttribute('data-money-format');
      var price = root.querySelector('[data-mgz-price]');
      var compare = root.querySelector('[data-mgz-compare]');
      if (variant && price) price.textContent = formatMoney(variant.price, format);
      if (compare) {
        var onSale = !!variant && variant.compare_at_price > variant.price;
        compare.hidden = !onSale;
        if (onSale) compare.textContent = formatMoney(variant.compare_at_price, format);
      }

      var form = document.getElementById(root.getAttribute('data-form-id'));
      var idInput = form && form.querySelector('input[name="id"]');
      if (idInput && variant) idInput.value = variant.id;

      var btn = root.querySelector('[data-mgz-atc]');
      if (btn && !btn.hasAttribute('data-mgz-blocked')) {
        if (!variant) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); }
        else if (!variant.available) { btn.disabled = true; btn.textContent = btn.getAttribute('data-soldout'); }
        else { btn.disabled = false; btn.textContent = btn.getAttribute('data-add'); }
      }
      var dynamic = root.querySelector('[data-mgz-dynamic]');
      if (dynamic) dynamic.hidden = !(variant && variant.available);

      if (moveImage && variant && variant.featured_media) {
        var track = root.querySelector('[data-mgz-track]');
        var list = track ? items(track) : [];
        var idx = list.findIndex(function (el) { return el.getAttribute('data-media-id') == variant.featured_media.id; });
        if (idx > -1) goTo(track, idx);
      }
    }

    function initBuy() {
      document.querySelectorAll('[data-mgz-buy]:not([data-mgz-buy-ready])').forEach(function (root) {
        root.setAttribute('data-mgz-buy-ready', '');
        updateBuy(root, false);
      });
    }

    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.closest || !input.closest('[data-mgz-optset]')) return;
      var root = input.closest('[data-mgz-buy]');
      if (root) updateBuy(root, true);
    });

    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest && e.target.closest('[data-mgz-qty]');
      if (!qtyBtn) return;
      var input = qtyBtn.parentElement.querySelector('input');
      var next = (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.getAttribute('data-mgz-qty'), 10);
      input.value = Math.max(1, next);
    });

    /* ---------- イベント ---------- */
    var ticking = false;
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t && t.nodeType === 1 && t.hasAttribute('data-mgz-track')) {
        clearTimeout(t.__mgzTimer);
        t.__mgzTimer = setTimeout(function () { syncDots(t); }, 60);
        return;
      }
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { ticking = false; updateProgress(); });
      }
    }, { capture: true, passive: true });

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      var btn = e.target.closest('[data-mgz-prev], [data-mgz-next], [data-mgz-dot]');
      if (btn) {
        var root = btn.closest('[data-mgz-carousel]');
        var track = root && root.querySelector('[data-mgz-track]');
        if (!track) return;
        e.preventDefault();
        var cur = currentIndex(track);
        if (btn.hasAttribute('data-mgz-prev')) goTo(track, cur - 1);
        else if (btn.hasAttribute('data-mgz-next')) goTo(track, cur + 1);
        else goTo(track, parseInt(btn.getAttribute('data-mgz-dot'), 10));
        return;
      }

      var link = e.target.closest('a[href^="#mgz-h-"]');
      if (link) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', link.getAttribute('href'));
      }
    });

    function init() { updateProgress(); initAnim(); initBuy(); }
    window.addEventListener('resize', updateProgress);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();
})();
